import RenderSpotifyPlayer from './RenderSpotifyPlayer';

export default RenderSpotifyPlayer;
